"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bn_js_1 = __importDefault(require("bn.js"));

var bn_1 = require("./bn");

var helpers_1 = require("./helpers");

var hex_1 = require("./hex");

function toNumber(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var result = null;

  switch (typeof value) {
    case 'boolean':
      result = value ? 1 : 0;
      break;

    case 'string':
      if (hex_1.isHex(value, 'quantity')) {
        result = parseInt(value.slice(2), 16);
      } else {
        result = parseInt(value, 10);
      }

      break;

    case 'number':
      result = value;
      break;

    case 'object':
      if (bn_js_1.default.isBN(value)) {
        result = value.toNumber();
      }

      break;
  }

  return helpers_1.isEmpty(result) ? defaultValue : result;
}

exports.toNumber = toNumber;

function toNumberString(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var result = null;

  switch (typeof value) {
    case 'number':
      value = value;
      result = value.toString(10);
      break;

    case 'string':
      value = value;

      if (hex_1.isHex(value, 'quantity')) {
        result = bn_1.toBN(value).toString(10);
      } else if (/^[0-9]*\.?[0-9]+$/g.test(value)) {
        result = value;
      }

      break;

    case 'object':
      if (bn_js_1.default.isBN(value)) {
        result = value.toString(10);
      }

      break;
  }

  if (result) {
    result = trimNumberString(result);
    var shift = options.shift,
        precision = options.precision;

    if (shift) {
      if (!result.includes('.')) {
        result = "".concat(result, ".0");
      }

      var extra = '0'.repeat(shift > 0 ? shift : -shift);
      result = "".concat(extra).concat(result).concat(extra);
      var dotPosition = result.indexOf('.');
      result = result.replace('.', '');

      if (shift > 0) {
        result = [result.slice(0, dotPosition + shift), result.slice(dotPosition + shift)].join('.');
      } else {
        result = [result.slice(0, dotPosition + shift), result.slice(dotPosition + shift)].join('.');
      }

      result = trimNumberString(result);
    }

    if (Number.isInteger(precision)) {
      if (!result.includes('.')) {
        if (precision) {
          result = "".concat(result, ".").concat('0'.repeat(precision));
        }
      } else if (!precision) {
        result = result.slice(0, result.indexOf('.'));
      } else {
        var parts = result.split('.');
        var extraCount = parts[1].length - precision;

        if (extraCount > 0) {
          parts[1] = parts[1].substr(0, precision);
        } else if (extraCount < 0) {
          parts[1] = "".concat(parts[1]).concat('0'.repeat(-extraCount));
        }

        result = parts.join('.');
      }
    }
  }

  return result;
}

exports.toNumberString = toNumberString;

function trimNumberString(value) {
  var result = null;

  if (value) {
    var parts = value.split('.');
    parts[0] = parts[0].replace(/^(0+)/g, '');
    parts[1] = (parts[1] || '').replace(/(0+)$/g, '');

    if (!parts[0]) {
      parts[0] = '0';
    }

    if (parts[1]) {
      result = parts.join('.');
    } else {
      result = parts[0];
    }
  }

  return result;
}

exports.trimNumberString = trimNumberString;